<template>
    <BaseCard
        class="animate-pulse overflow-hidden !p-0"
        data-spec-class="card-skeleton"
    >
        <div class="bg-surface/50 flex items-center gap-x-4 p-6">
            <div class="text-xl leading-6 font-medium">
                <div class="h-4 w-32 rounded-sm bg-muted" />
            </div>
        </div>

        <dl class="-my-3 divide-y divide-divider bg-surface px-6 py-4 leading-6">
            <div class="flex justify-between py-3">
                <dt class="text-tertiary">
                    <div class="h-4 w-20 rounded-sm bg-secondary--inverse" />
                </dt>
                <dd class="text-secondary">
                    <div class="h-4 w-24 rounded-sm bg-muted" />
                </dd>
            </div>
            <div class="flex justify-between py-3">
                <dt class="text-tertiary">
                    <div class="h-4 w-16 rounded-sm bg-secondary--inverse" />
                </dt>
                <dd class="text-secondary">
                    <div class="h-4 w-32 rounded-sm bg-muted" />
                </dd>
            </div>
            <div class="flex justify-between py-3">
                <dt class="text-tertiary">
                    <div class="h-4 w-24 rounded-sm bg-secondary--inverse" />
                </dt>
                <dd class="text-secondary">
                    <div class="h-4 w-20 rounded-sm bg-muted" />
                </dd>
            </div>
        </dl>
    </BaseCard>
</template>

<script setup lang="ts">
// No props needed - always uses Normal size
</script>
